import { render, staticRenderFns } from "./RegistrationHero.vue?vue&type=template&id=5dce5700&"
import script from "./RegistrationHero.vue?vue&type=script&lang=js&"
export * from "./RegistrationHero.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationHero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports